module.exports = __webpack_public_path__ + "static/img/mbanner-12.764642c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mimage/mbanner-12.jpg
// module id = hXVU
// module chunks = 1